import { AxiosResponse } from 'axios';
import api from './Api'


export const getTeacherAndLectureList = (id: string): Promise<AxiosResponse<ITeacherDetail, any>> => {
    return api.get(`/mobile/teacher/${id}`);
}

export const getMyTeacherStatus = () => {
    return api.get<string>('/mobile/teacher/status');
}